import React from 'react';
import { useSelector } from 'react-redux';
import { isEditingZoomState } from '../../../../../app/redux/retrievers/retrievers';
import { MapLeafletContainerStyles } from '../../../base/styles/MapLeafletContainer.styles';

interface MapLockOverlayProps {
    isUserAuthorized: boolean;
    isMapLocked: boolean;
}
const MapLockOverlay: React.FC<MapLockOverlayProps> = ({ isMapLocked, isUserAuthorized }) => {
    const isEditingZoom = useSelector(isEditingZoomState);
    if ((isMapLocked && !isEditingZoom) || !isUserAuthorized) return <div style={MapLeafletContainerStyles.HolderLocked} />;
    else return null;
};
export default MapLockOverlay;
